import { PackageDownIcon } from './PackageDownIcon';

/**
 * author: Google
 * id 0C18B335-700A-4D68-BF88-C95A69479F2E
 * name package-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-down.svg
 * tags
 */
export const BoxDownIcon = PackageDownIcon;
export default BoxDownIcon